import { SideNavItem } from '../rankings/models/sideNavItem';

export const SIDENAV_ITEMS: Array<SideNavItem> = [];
